import { Order } from 'hooks/account/types'
import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import priceString from 'utils/priceString'
import config from 'config'
import useTranslations from 'hooks/useTranslations'

type Props = {
  order: Order
  'data-cy-state': string
  orderNotOlderThan24Hours: boolean
}

export function InfoLine(props: Props) {
  const t = useTranslations<'molecules-account-Minicart'>()
  return (
    <Wrapper className="InfoLine" data-cy-state={props['data-cy-state']}>
      <div className="attributes">
        <div className="item">
          <div className="label">{t('infoline_order_date')}</div>
          <div className="value">
            {new Date(props.order.createdAt).toLocaleDateString(
              config.i18n.locale
            )}
          </div>
        </div>
        <div className="item">
          <div className="label">{t('infoline_sum')}</div>
          <div className="value">{priceString(props.order.totalPrice)}</div>
        </div>
        <div className="item">
          <div className="label">{t('infoline_order_number')}</div>
          <div className="value">{props.order.orderNumber}</div>
        </div>
      </div>
      {props.order.paymentNecessary && (
        <PaymentNecessaryStatus data-cy-state="show-payment-necessary">
          <div className="circle" />
          <span>
            {props.orderNotOlderThan24Hours
              ? t('infoline_payment_necessary')
              : t('infoline_payment_canceled')}
          </span>
        </PaymentNecessaryStatus>
      )}
    </Wrapper>
  )
}

export default InfoLine

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing('xs')};
  @media (min-width: ${theme.ms.MD}px) {
    flex-direction: row;
    justify-content: space-between;
  }

  > .attributes {
    display: flex;
    gap: ${theme.spacing('m')};

    > .item > .label {
      ${theme.ty('rc-xs', null, 'rc-s')}
      margin-bottom: 2px;
    }
    > .item > .value {
      ${theme.ty('rc-s', 'bold', 'rc-base')}
    }
  }
`

const PaymentNecessaryStatus = styled.div`
  display: flex;
  align-items: center;
  > .circle {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: ${theme.colors.accent.red};
    margin-right: ${theme.spacing('xxs')};
  }
  > span {
    ${theme.ty('rc-xs', null, 'rc-s')}
    color: ${theme.colors.accent.red};
  }
`
